import AdministratorsListView from './components/views/administrators/AdministratorsList.vue'
import AgentsListView from './components/views/agents/AgentsList.vue'
import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import ResetPassword from './components/ResetPassword.vue'
import MapView from './components/views/map/Map.vue'
import NotFoundView from './components/404.vue'
import RondesListView from './components/views/rondes/RondesList.vue'
import RondeView from './components/views/rondes/Ronde.vue'
import AnomaliesListView from './components/views/anomalies/AnomaliesList.vue'
import AnomalieDownloadImage from './components/views/anomalies/AnomalieDownloadImage.vue'
import ReportingView from './components/views/reporting/Reporting.vue'

const routes = [
  {
    path: '/login',
    component: LoginView,
    name: 'Login',
  },
  {
    path: '/resetPassword/:adminId',
    component: ResetPassword,
    name: 'ResetPassword',
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'map',
        alias: '',
        component: MapView,
        name: 'Carte',
        meta: {
          description: 'Visualiser les tournées',
        },
      },
      {
        path: 'rondes',
        alias: '',
        component: RondesListView,
        name: 'Rondes',
        meta: {
          description: 'Liste des rondes',
        },
      },
      {
        path: 'ronde/:id',
        alias: '',
        component: RondeView,
        name: 'Ronde',
        meta: {
          description: 'Détails d\'une ronde',
          parent: {
            name: 'Rondes',
            path: 'rondes',
          },
        },
      },
      {
        path: 'agents',
        alias: '',
        component: AgentsListView,
        name: 'Agents',
        meta: {
          description: 'Liste des agents',
        },
      },
      {
        path: 'administrateurs',
        alias: '',
        component: AdministratorsListView,
        name: 'Administrateurs',
        meta: {
          description: 'Liste des administrateurs',
        },
      },
      {
        path: 'anomalies',
        alias: '',
        component: AnomaliesListView,
        name: 'Événements',
        meta: {
          description: 'Liste des événements',
        },
      },
      {
        path: 'anomalies/image/:id',
        alias: '',
        component: AnomalieDownloadImage,
        name: 'Image-anomalie',
        meta: {
          description: 'Image de l\'anomalie',
        },
      },
      {
        path: 'reporting',
        alias: '',
        component: ReportingView,
        name: 'Reporting',
        meta: {
          description: '',
        },
      },
    ],
  }, {
    // not found handler
    path: '*',
    component: NotFoundView,
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js